import { Box } from "@chakra-ui/react";
import BottomNavbar from "./NavComponents/DesktopBottomNavbar";
import TopNavbar from "./NavComponents/DesktopTopNavbar";
import BottomList from "./NavComponents/BottomList";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const DesktopNavbar = () => {
  const [location, setlocation] = useState();
  let currlocation = useLocation();
  let isLoggedIn = localStorage.getItem("isLoggedIn");
  useEffect(() => {
    setlocation(currlocation);
    document.title = "Udyog - Aapka Apna Saathi | Procure 12500+ Medicines";
  }, [useLocation()]);
  
  return (
    <Box>
      { currlocation.pathname == "/dashboard"? <></> : <div>
      <TopNavbar></TopNavbar>
      {isLoggedIn ? 
        <Box>
          <BottomNavbar />
          <BottomList />
        </Box>
        : <></>
      }
      </div>}
    </Box>

  );
};

export default DesktopNavbar;
